import React from 'react'
import About from './About'
import Books from './Books'
import Contact from './Contact'
import Poster from './Poster'
import Coursel from './Coursel'
import CustomerReview from './CustomerReview'
function Home() {
  return (
    <>
    
    <Poster />
    <Coursel />
    <Books />

    <About />

    <Contact />

    <CustomerReview />
    
    </>

  )
}

export default Home